// The bow heading of a hull under the approach (R2371, R2376;
// ui-map-interface.md §6.1.10).
//
// Under the approach (every world, R2400), the server sends the direction of
// each hull's bow (`FleetState.heading_mrad`), and the fleet layer draws
// the hull along it, not along its travel. The wire heading moves in
// steps at the frame rate of the server, so the layer turns the drawn
// heading toward the wire heading with the same exponential approach that
// it uses for the position, the shortest way round.
//
// The module is pure: it imports nothing and keeps no state.

import { TAU } from './math';

/** `a` wrapped into the half-open turn (-π, π]. */
export function wrapAngle(a: number): number {
  if (!Number.isFinite(a)) return 0;
  let r = a % TAU;
  if (r <= -Math.PI) r += TAU;
  else if (r > Math.PI) r -= TAU;
  return r;
}

/** The signed turn from `from` to `to` the shortest way round, in
 *  (-π, π]. A turn of exactly a half turn goes counter-clockwise (+π). */
export function angleGap(from: number, to: number): number {
  return wrapAngle(to - from);
}

/**
 * The drawn heading one frame later: `cur` turned the share `k` (0..1) of
 * the shortest gap toward `target`, wrapped into (-π, π]. `k` is the
 * position ease of the layer, `1 - exp(-dt / τ)`, so the bow and the place
 * settle together.
 */
export function turnToward(cur: number, target: number, k: number): number {
  return wrapAngle(cur + angleGap(cur, target) * k);
}

/** The bow heading of the wire in radians: milliradians over 1000. */
export function bowOfWire(headingMrad: number): number {
  return headingMrad / 1000;
}
